// TIP-609 — the two button shapes the design uses, at its two scales.
//   primary   → orange fill, white text
//   secondary → transparent with a #DCE3E8 hairline
//   lg (14px 24px / 15px) on the card and the gate, sm (9px 16px / 13px) in
// Every value, hover included, is in counterpartyBriefs.css.
import React from "react";
import "./counterpartyBriefs.css";

const CbButton = ({ variant = "primary", size, tone, light, className = "", children, ...rest }) => {
  const classes = [
    "cb-btn",
    `cb-btn--${variant}`,
    size === "sm" && "cb-btn--sm",
    tone && `cb-btn--${tone}`,
    light && "cb-btn--light",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
};

export default CbButton;
